import * as Dialog from "@radix-ui/react-dialog";
import closeIcon from "../assets/images/close.svg";

export default function ConfirmModal({
  open,
  onOpenChange,
  title = "Do you want to remove the file?",
  onConfirm,
  confirmText = "Remove",
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex sm:items-center sm:justify-center items-end justify-center">
          <Dialog.Content
            className="w-full md:w-[400px] sm:mx-4 sm:rounded-2xl rounded-t-2xl bg-white px-4 pt-3 pb-6 shadow-xl relative flex flex-col
             sm:bottom-auto sm:translate-y-0 bottom-0 translate-y-0
             animate-in fade-in-90 slide-in-from-bottom-8"
            style={{ maxWidth: "100vw" }}
          >
            <div className="py-4 border-b flex justify-between items-center">
              <h3 className="font-medium">{title}</h3>
              <Dialog.Close asChild>
                <button
                  className="outline-none text-gray-400 hover:text-gray-600 transition-colors p-2 rounded-full"
                  aria-label="Close"
                >
                  <img src={closeIcon} alt="Close" className="w-5 h-5" />
                </button>
              </Dialog.Close>
            </div>

            <div className="pt-6">
              <button
                onClick={onConfirm}
                className={`w-full flex items-center justify-center gap-2 uppercase font-bold bg-purpleGradient text-white px-4 py-3 rounded-[10px] hover:bg-purpleGradientDark transition-colors`}
              >
                <span>{confirmText}</span>
              </button>
              <Dialog.Close asChild>
                <button className="w-full border-2 border-darkGrey font-bold text-darkGrey px-4 py-3 rounded-xl transition-colors mt-4">
                  Cancel
                </button>
              </Dialog.Close>
            </div>
          </Dialog.Content>
        </div>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
